import React from 'react';
import Layout from '../../components/Layout';
import HeadMessage from '../../components/Common/HeadMessage/HeadMessage';
import Breadcrumbs from '../../components/Breadcrumbs';
import HowTo from './HowTo';
import { breadcrumbSchema, canonicalUrl, SITE_URL } from '../../utils/seo';
import { isReleased } from '../../data/widgets/release';

/**
 * /how-to-change-new-tab
 *
 * Информационный запрос («how to change the chrome new tab page») — верх
 * воронки. Страница отвечает на вопрос целиком, включая варианты без нашего
 * расширения; продажа только в конце и с явной пометкой, что продукт наш.
 *
 * HowTo-разметку сознательно не ставим: Google снял её с rich-результатов
 * в сентябре 2023. @see docs/seo/SEO-STRATEGY.md
 */
function action() {
	const url = '/how-to-change-new-tab';

	// Страница из очереди поэтапной публикации: до своей даты её нет.
	// @see src/data/widgets/release.js
	if (!isReleased(url)) {
		return undefined;
	}

	return {
		title: 'How to Change the New Tab Page in Chrome',
		description:
			"Change the background and shortcuts with Chrome's own settings, or replace the page entirely with an extension — and how to put it back if you change your mind.",
		chunks: ['how-to'],
		jsonLd: [
			{
				'@context': 'https://schema.org',
				'@type': 'WebPage',
				'@id': `${canonicalUrl(url)}#webpage`,
				url: canonicalUrl(url),
				name: 'How to change the new tab page in Chrome',
				description:
					'What Chrome can and cannot change about its new tab page, how to replace it with an extension, what to check before installing one, and how to revert.',
				isPartOf: { '@id': `${SITE_URL}/#website` },
			},
			breadcrumbSchema([
				{ name: 'Home', url: '/' },
				{ name: 'How to change the new tab page', url },
			]),
		],
		component: (
			<Layout>
				<Breadcrumbs
					items={[
						{ name: 'Home', url: '/' },
						{ name: 'Changing the new tab page' },
					]}
				/>

				<HeadMessage variant="compact">
					<h1>How to change the new tab page in Chrome</h1>
				</HeadMessage>

				<HowTo />
			</Layout>
		),
	};
}

export default action;
